import React from 'react'
import _ from 'lodash'
import { Row, Col, Typography } from 'antd'
import { Button, Icon, Popover } from '@vzmi/shp_shared_compo'
import { showOnlyNumber } from '@vzmi/component_ec_nodejs_util/dist/lib/formatter'
import { Field } from '../../../../../Common/forms'
import {
  SingleLineTextField,
  InputField,
  InputCountField,
  HyperLink
} from '../../../../../Common/Form'
import ExtraModelTable from '../../ExtraModelTable'
import {
  TABLE_TYPE,
  FORM,
  COLUMN,
  ATTR_NAME_LIMIT,
  DISPLAY_NAME_VALIDATION_TYPE,
  getRenderId,
  displayNameValidationChain,
  getGrossMargin,
  requiredValidation
} from '../helper'
import withTableActions from '../withTableActions'
import styles from '../index.css'

const { Paragraph } = Typography

const tableType = TABLE_TYPE.ADDITIONAL_PURCHASES
const renderField = FORM[tableType]

const AdditionalPurchases = props => {
  const {
    change,
    readOnly,
    isDataEmpty,
    isMultipleAttrType,
    title,
    tableData,
    removeRow,
    removeAllRows,
    onFieldChange,
    onOpenNewComplimentariesModal
  } = props

  const columns = [
    {
      title: '商品編號 / 商品名稱',
      width: 200,
      dataIndex: COLUMN.NAME,
      key: COLUMN.NAME,
      render: (text, record, index) => {
        const renderId = getRenderId(record)
        const { [COLUMN.IS_NEW]: isNew } = record
        return (
          <>
            <div>
              {isNew && (
                <>
                  <Icon
                    name='ec-flash'
                    color='#ec457d'
                    align='bottom'
                    size={24}
                  />
                  <span>NEW</span>
                </>
              )}
              <Field
                name={`${renderField}.${renderId}.${COLUMN.ID}`}
                component={SingleLineTextField}
              />
            </div>
            <Paragraph ellipsis={{ rows: 2 }}>
              <Field
                name={`${renderField}.${renderId}.${COLUMN.NAME}`}
                component={SingleLineTextField}
              />
            </Paragraph>
          </>
        )
      }
    },
    {
      title: () => (
        <Popover content='顯示於賣場上的超值加購品名稱'>
          加購品顯示名稱
        </Popover>
      ),
      width: 200,
      dataIndex: COLUMN.ATTR_NAME,
      key: COLUMN.ATTR_NAME,
      className: styles.verticalAlignTop,
      render: (text, record, index) => {
        const renderId = getRenderId(record)
        const rowId = `${renderField}.${renderId}`
        return (
          <Field
            name={`${rowId}.${COLUMN.ATTR_NAME}`}
            component={InputCountField}
            onChange={onFieldChange}
            countLimit={ATTR_NAME_LIMIT}
            disabled={readOnly}
            validate={displayNameValidationChain(
              tableType,
              renderId,
              DISPLAY_NAME_VALIDATION_TYPE.NO_ATTR_INPUT
            )}
            alwaysIgnoreError={readOnly}
            mustShowFormError={!readOnly}
            showErrorOnActive
            keepErrorPosition
          />
        )
      }
    },
    {
      title: '售價 / 成本 / 毛利率',
      width: 200,
      dataIndex: COLUMN.COST,
      key: COLUMN.COST,
      className: styles.verticalAlignTop,
      render: (text, record, index) => {
        const {
          [COLUMN.PRICE]: price = 0,
          [COLUMN.COST]: cost = 0
        } = record
        const renderId = getRenderId(record)
        const rowId = `${renderField}.${renderId}`
        const grossMargin = `${getGrossMargin(+price, +cost)}%`
        return (
          <>
            <Field
              name={`${rowId}.${COLUMN.PRICE}`}
              component={InputField}
              onChange={onFieldChange}
              disabled={readOnly}
              validate={requiredValidation}
              parse={showOnlyNumber}
              format={showOnlyNumber}
              alwaysIgnoreError={readOnly}
              mustShowFormError={!readOnly}
              keepErrorPosition
            />
            <div className={styles.cost}>
              {+cost}
            </div>
            <div className={styles.grossMargin}>
              {grossMargin}
            </div>
          </>
        )
      }
    },
    {
      title: '可售數量',
      width: 90,
      dataIndex: COLUMN.STOCK,
      key: COLUMN.STOCK,
      align: 'right',
      render: (text, record, index) => {
        const proudctCount = _.get(record, COLUMN.AVAILABLE_COUNT, _.get(record, COLUMN.STOCK, null))
        return +proudctCount === 0 ? null : proudctCount
      }
    },
    {
      title: '供應商商品料號',
      width: 120,
      dataIndex: COLUMN.PART_NO,
      key: COLUMN.PART_NO,
      render: (text, record, index) => {
        const renderId = getRenderId(record)
        return (
          <Field
            name={`${renderField}.${renderId}.${COLUMN.PART_NO}`}
            component={SingleLineTextField}
            defaultEmptyString
          />
        )
      }
    }
  ]

  return (
    <>
      <Row
        wrap={false}
        align='middle'
      >
        <Col flex='50%' />
        <Col flex='auto' />
        <Col flex='20%'>
          <Row justify='end'>
            <Col>
              {!readOnly && (
                <Button
                  size='medium'
                  buttonType='outline'
                  data-role='remove-all-extra-models'
                  onClick={removeAllRows}
                  disabled={isDataEmpty}
                  fluid
                >
                  清空
                  {title}
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <ExtraModelTable
        tableType={tableType}
        tableData={tableData}
        columns={columns}
        isMultipleAttrType={isMultipleAttrType}
        removeRow={removeRow}
        readOnly={readOnly}
        change={change}
      />
      {
        !readOnly && (
          <>
            <br />
            <Row>
              <Col flex='auto'>
                <HyperLink
                  data-role='import-extra-models'
                  onClick={onOpenNewComplimentariesModal}
                >
                  <Icon
                    name='add-attachments'
                    color='#5478fc'
                    size={14}
                    align='middle'
                    style={{ cursor: 'pointer' }}
                  />
                  {` ${`匯入${title}`}`}
                </HyperLink>
              </Col>
            </Row>
          </>
        )
      }
    </>
  )
}

const props = { tableType }
export default withTableActions(AdditionalPurchases, props)
